import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assests/images/dreamClosetLogo.png';
import '../assests/css/Navbar.css';
import { ProductContext } from '../App';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

function Navbar() {

    const product_context = useContext(ProductContext);
    const { orderTableCategory, setOrderTableCategory, setSoldDataSearchById, user, setUser } = product_context;

    const [navbarIsOpen, setNavbarIsOpen] = useState(false);
    const [stockListIsOpen, setStockListIsOpen] = useState(false);
    const [orderListIsOpen, setOrderListIsOpen] = useState(false);

    const location = useLocation();

    const handleLogout = () => {
        setUser();
        localStorage.removeItem('token');
    }

    return (
        <>
            <div className="header d-flex position-sticky">
                <Link to='/'><img className='mx-3' src={logo} alt="..." /></Link>
                <ul className={`navbar ${navbarIsOpen ? 'active' : ''}`}>
                    <CloseIcon onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} className="fa-solid fa-xmark fa-2x" />
                    {/* <i onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} className="fa-solid fa-xmark fa-2x"></i> */}

                    <li><Link onClick={() => {
                        setOrderListIsOpen(false);
                        setStockListIsOpen(false);
                        setSoldDataSearchById('');
                        setNavbarIsOpen(!navbarIsOpen);
                    }} to='/' className={`${location.pathname === '/' ? 'active' : ''}`}>Dashboard</Link></li>

                    <li onClick={() => {
                        setStockListIsOpen(!stockListIsOpen);
                        setOrderListIsOpen(false);
                        setSoldDataSearchById('');
                        setNavbarIsOpen(!navbarIsOpen);
                    }}><Link to='/stocktable' className={`${location.pathname === '/stocktable' ? 'active' : ''}`}>Stock</Link></li>


                    <li><Link onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} to='/sellstock' className={`${location.pathname === '/sellstock' ? 'active' : ''}`}>Sell Item</Link></li>


                    <li onClick={() => {
                        setOrderListIsOpen(!orderListIsOpen);
                        setStockListIsOpen(false);
                        setSoldDataSearchById('');
                    }}>Sales Tables</li>


                    <ul className={`orders ${orderListIsOpen ? 'active' : ''}`}>
                        <li><Link className={`${location.pathname === '/orderstable' && orderTableCategory === 'ordertable' ? 'active' : ''}`} to='/orderstable' onClick={() => {
                            setOrderTableCategory('ordertable')
                            setNavbarIsOpen(!navbarIsOpen)
                        }}>Orders Tables</Link></li>

                        <li><Link className={`${location.pathname === '/orderstable' && orderTableCategory === 'processingtable' ? 'active' : ''}`} to='/orderstable' onClick={() => {
                            setOrderTableCategory('processingtable')
                            setNavbarIsOpen(!navbarIsOpen)
                        }}>Processing Tables</Link></li>

                        <li><Link className={`${location.pathname === '/orderstable' && orderTableCategory === 'deliverytable' ? 'active' : ''}`} to='/orderstable' onClick={() => {
                            setOrderTableCategory('deliverytable')
                            setNavbarIsOpen(!navbarIsOpen)
                        }}>Delivery Table</Link></li>

                        <li><Link className={`${location.pathname === '/orderstable' && orderTableCategory === 'exchangetable' ? 'active' : ''}`} to='/orderstable' onClick={() => {
                            setOrderTableCategory('exchangetable');
                            setNavbarIsOpen(!navbarIsOpen)
                        }}>Return Table</Link></li>
                    </ul>

                    {user?.role === 'admin' ? <li><Link onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} to='/accounts' className={`${location.pathname === '/accounts' ? 'active' : ''}`}>Account</Link></li> : null}

                    <li><Link onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} to='/soldoutorder' className={`${location.pathname === '/soldoutorder' ? 'active' : ''}`}>Sold Out Orders</Link></li>

                    {user ? <div className="logout">
                        <button onClick={handleLogout} className='btn btn-danger mx-3 my-3'>Logout</button>
                    </div> : null}


                </ul>
                <MenuIcon onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} className="fa-solid fa-bars fa-2x mx-5" />
                {/* <i onClick={() => { setNavbarIsOpen(!navbarIsOpen) }} className="fa-solid fa-bars fa-2x mx-5"></i> */}
            </div>
        </>
    )
}

export default Navbar
